import React, { useEffect, useState } from "react";
import useTable from "../../../useTableR";
import axios from "axios";
import { Dimmer } from "../../../spinner";
import { Mensaje, MensajeSiNo } from "../../../mensajes2";
import CatalogoComercio from "../../../../catalogos/catalogoComercio";
import CatalagoVehiculo from "../../../../catalogos/catalogoVehiculosAll";
import CatalogoInmueble from "../../../../catalogos/catalogoInmueble";
import moment from "moment";
import { ActualizarEstadoCuenta } from "../../actividadEconomica/modalActualizarEstadoCuenta";
import { EstadoCuentaInmuebleModal } from "../../inmueblesUrbanos/modalEstadoInmueble";
import { ActualizarEstadoVehiculos } from "../../impuestovehiculos/modalActualizarEstadoVehiculos";
import { EstadoCuentaRentas } from "../../rentaInmobiliaria/modalEstadoCuentaEjido";
import { ConsultarDeuda } from "../../propagandaypublicidad/modalConsultarDeuda";
import { ModalCuentaEstado } from "../../impuestoLicores/modalEstadoLic";
import {
  formatMoneda,
  formatoMonto,
  validaSoloNumero,
} from "../../../../util/varios";
import {
  comercioService,
  inmuebleService,
  aseoService,
  vehiculoService,
  publicidadService,
  licoresService,
  solvenciasService,
} from "./services";
import ModalSolvencia from "./modalConsultarSolvencia";
import ModalComresis from "./modalComresis";
import html2pdf from "html2pdf.js";
const TablaConsultaGeneralDeudas = (props) => {
  const op = require("@/modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const espiritu = localStorage.getItem("espiritu");
  const afiliado = JSON.parse(localStorage.getItem("riforg"));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const fechaFormat = new Date().toISOString().split("T")[0];
  const anioactu = JSON.parse(localStorage.getItem("anioactu"));
  const fechaUnMesMas = new Date();
  fechaUnMesMas.setMonth(fechaUnMesMas.getMonth() + 1);
  const fechaUnMesMasFormat = fechaUnMesMas.toISOString().split("T")[0];
  const filtro = [
    {
      id: "Todo",
      label: "Todo",
    },
    {
      id: "cedula",
      label: "Solo Cedula",
    },
    {
      id: "rif",
      label: "Solo Rif",
    },
  ];
  const tipoImpuesto = [
    {
      id: "idComercio",
      tabla: "comercio",
      label: "Actividades Economicas",
      campos: "nombre, direccion, rif, reprelegal",
      condi: `idcomercio`,
    },
    {
      id: "idInmueble",
      tabla: "inmueble",
      label: "Inmuebles Urbanos",
      campos: ` nombrepropie as nombre, replace(cedulapropie, '.','') as rif, replace(cedulapropie, '.','') as reprelegal, (((((((((
            CASE
            WHEN lower(dirinmue1::text) = 'null'::text OR dirinmue1 IS NULL THEN ' '::text
            ELSE dirinmue1::text || ' '::text
        END ||
        CASE
            WHEN descridirinmue1 = 'null'::bpchar OR descridirinmue1 IS NULL THEN ' '::text
            ELSE descridirinmue1::text || ' '::text
        END) ||
        CASE
            WHEN lower(dirinmue2::text) = 'null'::text OR dirinmue2 IS NULL THEN ' '::text
            ELSE dirinmue2::text || ' '::text
        END) ||
        CASE
            WHEN lower(descridirinmue2::text) = 'null'::text OR descridirinmue2 IS NULL THEN ' '::text
            ELSE descridirinmue2::text || ' '::text
        END) ||
        CASE
            WHEN lower(dirinmue3::text) = 'null'::text OR dirinmue3 IS NULL THEN ' '::text
            ELSE dirinmue3::text || ' '::text
        END) ||
        CASE
            WHEN lower(descridirinmue3::text) = 'null'::text OR descridirinmue3 IS NULL THEN ' '::text
            ELSE descridirinmue3::text || ' '::text
        END) ||
        CASE
            WHEN lower(dirinmue4::text) = 'null'::text OR dirinmue4 IS NULL THEN ' '::text
            ELSE dirinmue4::text || ' '::text
        END) ||
        CASE
            WHEN lower(descridirinmue4::text) = 'null'::text OR descridirinmue4 IS NULL THEN ' '::text
            ELSE descridirinmue4::text || ' '::text
        END) ||
        CASE
            WHEN lower(dirinmue5::text) = 'null'::text OR dirinmue5 IS NULL THEN ' '::text
            ELSE dirinmue5::text || ' '::text
        END) ||
        CASE
            WHEN lower(descridirinmue5::text) = 'null'::text OR descridirinmue5 IS NULL THEN ' '::text
            ELSE descridirinmue5::text || ' '::text
        END) ||
        CASE
            WHEN btrim(lower(numcivicoinmue::text)) = 'null'::text OR numcivicoinmue IS NULL THEN ' '::text
            ELSE
            CASE
                WHEN btrim(lower(numcivicoinmue::text)) = ''::text THEN ' '::text
                ELSE ' N° '::text || numcivicoinmue::text
            END
        END as direccion `,
      condi: `idinmueble`,
    },
    {
      id: "idVehiculo",
      tabla: "vehiculo",
      label: "Patente de Vehiculo",
      campos:
        " nombrepropie as nombre, cedulapropie as rif, cedulapropie as reprelegal, direccionpropie as direccion",
      condi: `idvehiculo`,
    },
  ];
  const headCells = [
    {
      id: 0,
      label: "",
      width: "auto",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: 1,
      label: "Codigo",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: 2,
      label: "Rif",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: 3,
      label: "Nombre",

      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: 4,
      label: "Direccion",

      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: 5,
      label: "Representante Legal",

      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: 6,
      label: "Tipo Impuesto",

      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: 7,
      label: "Ultimo Periodo Pagado",

      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: 8,
      label: "Fecha Ultimo Pago",

      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: 9,
      label: "Monto Deuda",

      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: 10,
      label: "Opciones",

      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
  ];
  const [disabled, setDisabled] = useState(false);
  const [deudaTotal, setDeudaTotal] = useState("0,00");
  const [factorCambio, setFactorCambio] = useState(0);
  const [modalSolvencia, setModalSolvencia] = useState(false);
  const [mostrarModal, setMostrarModal] = useState({
    comercio: false,
    inmueble: false,
    vehiculo: false,
  });
  const [mostrarDetalles, setMostrarDetalles] = useState({
    actividad: false,
    publicidad: false,
    licores: false,
    vehiculos: false,
    inmobiliaria: false,
    aseo: false,
    local: false,
    terminal: false,
    comresis: false,
  });
  //Comercio
  const [comercio, setComercio] = useState(null);
  const [persona, setPersona] = useState(null);
  const [actividad, setActividad] = useState([]);
  const [actividadxCome, setActividadxCome] = useState([]);
  const [inmuebleCome, setInmuebleCome] = useState([]);
  const [deuda, setDeuda] = useState([]);
  const [historico, setHistorico] = useState([]);
  const [multas, setMultas] = useState([]);
  const [facturasPagadas, setFacturasPagadas] = useState([]);
  const [retencion, setRetencion] = useState([]);
  // Inmueble
  const [inmuebleI, setInmuebleI] = useState();
  const [deudaI, setDeudaI] = useState();
  const [historicoI, setHistoricoI] = useState();
  const [facturaRI, setFacturaRI] = useState();
  const [creditoI, setCreditoI] = useState();
  // Aseo
  const [inmobiliaria, setInmobiliaria] = useState();
  const [entidad, setEntidad] = useState();
  const [credito, setCredito] = useState();
  const [renta, setRentas] = useState();
  const [deudaA, setDeudaA] = useState();
  const [historicoA, setHistoricoA] = useState();
  const [valorUT, setValorUT] = useState();
  // Vehiculo
  const [vehiculo, setVehiculo] = useState();
  const [deudaV, setDeudaV] = useState();
  const [multasV, setMultasV] = useState();
  const [historicoV, setHistoricoV] = useState();
  // Publicidad
  const [comercioP, setComercioP] = useState();
  const [personaP, setPersonaP] = useState();
  const [deudaP, setDeudaP] = useState();
  const [history, setHistory] = useState();
  const [total, setTotal] = useState();
  const [recargo, setRecargo] = useState();
  const [valorut, setValorut] = useState();
  // Licores
  const [comercioL, setComercioL] = useState();
  const [deudaL, setDeudaL] = useState();
  const [historicoL, setHistoricoL] = useState();
  const [declaWeb, setDeclaWeb] = useState();
  const [valorUTL, setValorUTL] = useState();
  //Principal
  const [datosTabla, setDatosTabla] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingDeuda, setLoadingDeuda] = useState(false);
  const [itemSelect, setItemSelect] = useState({
    index: -1,
    item: "",
  });
  // Solvencias
  const [marcados, setMarcados] = useState([]);
  const [disabledSolv, setDisabledSolv] = useState(true);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [body, setBody] = useState({
    tipoImpuesto: tipoImpuesto[0],
    filtro: filtro[0],
    rif: "",
    codigo: "",
    cedula: "",
    nombre: "",
    direccion: "",
    fecha: fechaFormat,
    dirigido: "",
  });

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(datosTabla, headCells, filterFn);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setBody((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleInputNumChange = (event) => {
    validaSoloNumero(event);
    if (event.key === "Enter" || event.which === 13) {
      validarCampos();
    }
  };

  const validarCampos = () => {
    if (!body.codigo) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "El Código no debe estar vacio",
        icono: "informacion",
      });
    } else {
      buscarDatosGenerales();
    }
  };
  const formatPeriodo = (periodo) => {
    const periodoStr = String(periodo);
    if (!periodo || periodoStr.length !== 6) return "N/A";
    const mes = periodoStr.slice(4, 6);
    const año = periodoStr.slice(0, 4);
    return `${mes}-${año}`;
  };
  const seleccionarFila = (item, index) => {
    setItemSelect({
      index: index,
      item: item,
    });
  };

  // General
  const seleccionarFactorCambio = () => {
    let endpoint = `${op.conexion}/api/vehiculo/factorcambio`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setFactorCambio(response.data.valor);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };
  const buscarDatosGenerales = (id) => {
    setDisabled(true);
    const codigo = id ? id : body.codigo;
    setLoading(true);
    const campos = body.tipoImpuesto.campos;
    const nomtab = body.tipoImpuesto.tabla;
    const condi = `${body.tipoImpuesto.condi}=${codigo}`;
    const orden = body.tipoImpuesto.condi;
    const endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data.length > 0) {
          const data = response.data[0];
          setBody((prev) => ({
            ...prev,
            codigo: codigo,
            nombre: data.nombre,
            direccion: data.direccion || prev.direccion || "S/N",
            rif: data.rif,
            cedula:
              data.reprelegal && data.reprelegal !== "0"
                ? data.reprelegal
                : data.rif,
          }));
          const reprelegalValido =
            data.reprelegal !== null &&
            data.reprelegal !== undefined &&
            data.reprelegal !== "" &&
            parseInt(data.reprelegal) !== 0;

          const rifValido =
            data.rif !== null &&
            data.rif !== undefined &&
            data.rif !== "" &&
            parseInt(data.rif) !== 0;

          if (
            (!reprelegalValido && !rifValido) ||
            (body.filtro.id === "cedula" && !reprelegalValido)
          ) {
            setMensaje({
              mostrar: true,
              titulo: "Error",
              texto: "No Existen registros",
              icono: "informacion",
            });
            return;
          }
          switch (body.filtro.id) {
            case "cedula":
              buscarDeudas(data.reprelegal, data.reprelegal, data);
              break;
            case "rif":
              buscarDeudas(data.rif, data.rif, data);
              break;
            default:
              buscarDeudas(data.rif, data.reprelegal, data);
              break;
          }
        } else {
          setMensaje({
            mostrar: true,
            titulo: "",
            texto: "No Existen registros",
            icono: "informacion",
          });
          setDisabled(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: "Error al Buscar los Datos Generales",
          icono: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const buscarDeudas = async (codigo, rif, datosContribuyente) => {
    try {
      setLoadingDeuda(true);
      const campos = "*";
      const nomtab = `seleccionar_deudas_solvencias_fecven_web2('${codigo}','${rif}')`;
      const orden = "1";

      // 1. Traer deudas locales
      const preDeuda = await axios.get(
        `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`,
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      const resDeuda = preDeuda.data;
      const registroBase =
        resDeuda.find(
          (row) =>
            row.rif.trim() === `'${codigo}'` &&
            row.tipoImpuesto.trim() === "ACTIVIDADES ECONOMICAS",
        ) || {};
      let resComresis = [];
      const resInscrito = await axios.get(
        `https://comresis.opensiap.com.ve/api/api/opensiap/deuda_pendiente?rif=${codigo}`,
        {
          headers: {
            "X-AdminSecret": "6d8b99e73a4d7e99c2a4c66697c5cf08",
          },
        },
      );

      const datosInscrito = Array.isArray(resInscrito.data)
        ? resInscrito.data
        : [];

      if (datosInscrito.length > 0 && datosInscrito[0].registrado === true) {
        const preComresis = await axios.get(
          `https://comresis.opensiap.com.ve/api/api/opensiap/deuda_ultimo_pago?rif=${codigo}&cedula=${rif}`,
          {
            headers: {
              "X-AdminSecret": "6d8b99e73a4d7e99c2a4c66697c5cf08",
            },
          },
        );
        resComresis = Array.isArray(preComresis.data) ? preComresis.data : [];
      } else {
        if (registroBase.length === 0) {
          resComresis = [];
        } else {
          resComresis = [
            {
              paga: null,
              periodopagado: null,
              codigo: "S/N",
              rif: datosContribuyente.rif,
              nombre: datosContribuyente.nombre,
              direccion: datosContribuyente.direccion,
              reprelegal: rif,
              tipoimpuesto: "NO INSCRITO EN COMRESIS",
              mto_periodo: "0.00",
            },
          ];
        }
      }

      const fusionado = [...resDeuda, ...resComresis];
      if (fusionado.length === 0) {
        setMensaje({
          mostrar: true,
          titulo: "",
          texto: "No Existen registros",
          icono: "informacion",
        });
        setDisabled(false);
      } else {
        setDatosTabla(fusionado);
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Error al Buscar las Deudas",
        icono: "error",
      });
    } finally {
      setLoadingDeuda(false);
    }
  };

  const buscarDetalles = () => {
    const { item } = itemSelect;
    switch (item.tipoimpuesto) {
      case "ACTIVIDADES ECONOMICAS":
      case "MULTAS ACTIVIDADES ECONOMICAS":
        selectComercio(item.codigo);
        break;
      case "PUBLICIDAD COMERCIAL":
        selectPublicidad(item.codigo);
        break;
      case "RENTA DE LICORES":
        selectLicores(item.codigo);
        break;
      case "VEHICULOS":
        selectVehiculo(item.codigo);
        break;
      case "PROPIEDAD INMOBILIARIA":
        selectInmueble(item.codigo);
        break;
      case "ASEO URBANO":
      case "TERMINAL DE PASAJEROS":
      case "DISPOSICION RESIDUOS SOLIDOS":
      case "LOCAL":
        selectAseo(item.codigo);
        break;
      case "comresis":
        abrirModalDetalle();
        break;
      default:
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: "Tipo de Impuesto no Encontrado",
          icono: "error",
        });
    }
  };
  const abrirModalDetalle = () => {
    const { item } = itemSelect;
    switch (item.tipoimpuesto) {
      case "ACTIVIDADES ECONOMICAS":
      case "MULTAS ACTIVIDADES ECONOMICAS":
        setMostrarDetalles({
          actividad: true,
          publicidad: false,
          licores: false,
          vehiculos: false,
          inmobiliaria: false,
          aseo: false,
          local: false,
          terminal: false,
          comresis: false,
        });
        break;
      case "PUBLICIDAD COMERCIAL":
        setMostrarDetalles({
          actividad: false,
          publicidad: true,
          licores: false,
          vehiculos: false,
          inmobiliaria: false,
          aseo: false,
          local: false,
          terminal: false,
          comresis: false,
        });
        break;
      case "RENTA DE LICORES":
        setMostrarDetalles({
          actividad: false,
          publicidad: false,
          licores: true,
          vehiculos: false,
          inmobiliaria: false,
          aseo: false,
          local: false,
          terminal: false,
          comresis: false,
        });
        break;
      case "VEHICULOS":
        setMostrarDetalles({
          actividad: false,
          publicidad: false,
          licores: false,
          vehiculos: true,
          inmobiliaria: false,
          aseo: false,
          local: false,
          terminal: false,
          comresis: false,
        });
        break;
      case "PROPIEDAD INMOBILIARIA":
        setMostrarDetalles({
          actividad: false,
          publicidad: false,
          licores: false,
          vehiculos: false,
          inmobiliaria: true,
          aseo: false,
          local: false,
          terminal: false,
          comresis: false,
        });
        break;
      case "ASEO URBANO":
      case "TERMINAL DE PASAJEROS":
      case "DISPOSICION RESIDUOS SOLIDOS":
      case "LOCAL":
        setMostrarDetalles({
          actividad: false,
          publicidad: false,
          licores: false,
          vehiculos: false,
          inmobiliaria: false,
          aseo: true,
          local: false,
          terminal: false,
          comresis: false,
        });
        break;
      case "comresis":
        setMostrarDetalles({
          actividad: false,
          publicidad: false,
          licores: false,
          vehiculos: false,
          inmobiliaria: false,
          aseo: false,
          local: false,
          terminal: false,
          comresis: true,
        });
        break;
      default:
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: "Tipo de Impuesto no Encontrado",
          icono: "error",
        });
    }
  };

  const abrirCatalogo = () => {
    const { tipoImpuesto } = body;
    switch (tipoImpuesto.id) {
      case "idComercio":
        setMostrarModal({
          comercio: true,
        });
        break;
      case "idInmueble":
        setMostrarModal({
          inmueble: true,
        });
        break;
      case "idVehiculo":
        setMostrarModal({
          vehiculo: true,
        });
        break;
      default:
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: "Tipo de Impuesto no Encontrado",
          icono: "error",
        });
    }
  };

  // Comercio
  const selectComercio = async (idcomercio, item) => {
    setLoading(true);
    try {
      // Obtener comercio
      const comercioResponse = await comercioService.getComercio(
        idcomercio,
        token,
        op.conexion,
      );

      if (comercioResponse.status === 200) {
        setBody((prev) => ({
          ...prev,
          ...comercioResponse.mappedData.comercio,
        }));
        setComercio(comercioResponse.data);

        const { idactividad, idinmueble, esagente } =
          comercioResponse.mappedData.valores;

        if (comercioResponse.mappedData.persona) {
          setPersona(comercioResponse.mappedData.persona);
        }

        // Obtener actividad
        const actividadResponse = await comercioService.getActividad(
          idactividad,
          token,
          op.conexion,
        );
        if (
          actividadResponse.status === 200 &&
          actividadResponse.data.length > 0
        ) {
          setActividad(actividadResponse.data);
        }

        // Obtener actividad por comercio
        const anio = parseInt(localStorage.getItem("efiscalanio"));
        const actividadxComeResponse =
          await comercioService.getActividadxComercio(
            idcomercio,
            anio,
            token,
            op.conexion,
          );
        if (actividadxComeResponse.status === 200) {
          setActividadxCome(actividadxComeResponse.mappedData);
        }

        // Obtener inmueble
        const inmuebleResponse = await comercioService.getInmueblexComercio(
          idinmueble,
          token,
          op.conexion,
        );
        if (
          inmuebleResponse.status === 200 &&
          inmuebleResponse.data.length > 0
        ) {
          setInmuebleCome(inmuebleResponse.data);
        }

        // Obtener deudas
        const fechaSistema = new Date().toISOString().split("T")[0];
        const espiritu = 0;
        const deudaResponse = await comercioService.getDeudaComercio(
          idcomercio,
          fechaSistema,
          espiritu,
          token,
          op.conexion,
        );
        if (deudaResponse.status === 200) {
          const { deu, his } = deudaResponse.mappedData;
          setDeuda(deu);
          setHistorico(his);
        }

        // Obtener multas
        const multasResponse = await comercioService.getMultas(
          idcomercio,
          token,
          op.conexion,
        );
        if (multasResponse.status === 200) {
          setMultas(comercioService.mapMultas(multasResponse.data));
        }

        // Obtener facturas pagadas si es agente
        if (esagente) {
          const facturasResponse = await comercioService.getFacturasPagadas(
            idcomercio,
            token,
            op.conexion,
          );
          if (facturasResponse.status === 200) {
            setFacturasPagadas(facturasResponse.data);
          }
        }
        const retencionesResponse = await comercioService.getRetenciones(
          idcomercio,
          token,
          op.conexion,
        );
        if (retencionesResponse.status === 200) {
          setRetencion(retencionesResponse.data);
        }
        setLoading(false);
        abrirModalDetalle();
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: error.response?.data?.message || "Error al cargar los datos",
        icono: "error",
      });
      setLoading(false);
    }
  };

  // Inmueble
  const selectInmueble = async (idinmueble) => {
    setLoading(true);

    try {
      // Obtener datos del inmueble
      const inmuebleResponse = await inmuebleService.getInmueble(
        idinmueble,
        token,
        op.conexion,
      );

      if (
        inmuebleResponse.status === 200 &&
        inmuebleResponse.data.idinmueble > 0
      ) {
        const inmuebleData = inmuebleResponse.data;

        setInmuebleI(inmuebleData);
        setCreditoI(inmuebleResponse.mappedData.valores.credito);

        // Obtener deudas y facturas en paralelo
        const [deudaResponse, facturasResponse] = await Promise.all([
          inmuebleService.getDeudaInmueble(
            inmuebleData.idinmueble,
            fechaSistema,
            espiritu,
            factorCambio,
            token,
            op.conexion,
          ),
          inmuebleService.getFacturasRelacionadas(
            inmuebleData.idinmueble,
            token,
            op.conexion,
          ),
        ]);

        // Procesar deudas
        if (deudaResponse.status === 200) {
          const { deu, his } = deudaResponse.mappedData;
          setDeudaI(deu);
          setHistoricoI(his);
        }

        // Procesar facturas
        if (facturasResponse.status === 200) {
          setFacturaRI(facturasResponse.data);
        }
        setLoading(false);
        abrirModalDetalle();
      } else {
        setLoading(false);
      }
    } catch (error) {
      console.error("Error al cargar datos del inmueble:", error);
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto:
          error.response?.data?.message ||
          "Error al cargar los datos del inmueble",
        icono: "error",
      });
      setLoading(false);
    }
  };

  // Aseo
  const selectAseo = async (idrentas) => {
    setLoading(true);
    try {
      const response = await aseoService.getAseo(
        idrentas,
        token,
        op.conexion,
        fechaSistema,
        espiritu,
        anioactu,
        factorCambio,
      );

      if (response.status === 200) {
        setInmobiliaria(response.mappedData.renta);

        if (response.mappedData.entidad) {
          setEntidad(response.mappedData.entidad);
          setCredito(response.mappedData.credito);
        }

        if (response.mappedData.tipoRenta) {
          setRentas(response.mappedData.tipoRenta);
        }

        const { deu, his } = response.mappedData.deudas;
        setDeudaA(deu);
        setHistoricoA(his);
        setValorUT(response.mappedData.valorPetro);
        setLoading(false);
        abrirModalDetalle();
      }
    } catch (error) {
      console.log(error);
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto:
          error.response?.data?.message || "Error al cargar los datos de aseo",
        icono: "error",
      });
      setLoading(false);
    }
  };

  // Vehiculo
  const selectVehiculo = async (idvehiculo) => {
    setLoading(true);
    try {
      const response = await vehiculoService.getVehiculo(
        idvehiculo,
        token,
        op.conexion,
        fechaSistema,
        espiritu,
        factorCambio,
      );

      if (response.status === 200) {
        setVehiculo(response.mappedData.vehiculo);

        // Extraer deudas y historico correctamente
        const { deu, his } = response.mappedData.deudas;
        setDeudaV(deu); // deudas vigentes
        setHistoricoV(his); // historial de pagos

        setMultasV(response.mappedData.multas);
        setFactorCambio(response.mappedData.factorCambio);
      }
      setLoading(false);
      abrirModalDetalle();
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto:
          error.response?.data?.message ||
          "Error al cargar los datos del vehículo",
        icono: "error",
      });
      setLoading(false);
    }
  };

  // Publicidad
  const selectPublicidad = async (idcomercio) => {
    setLoading(true);
    try {
      const response = await publicidadService.getPublicidad(
        idcomercio,
        token,
        op.conexion,
        fechaSistema,
        espiritu,
        factorCambio,
      );

      if (response.status === 200) {
        setComercioP(response.mappedData.comercio);
        setPersonaP(response.mappedData.persona);
        setDeudaP(response.mappedData.deuda);
        setHistory(response.mappedData.history);
        setTotal(response.mappedData.total);
        setRecargo(response.mappedData.recargo);
        setValorut(response.mappedData.valorut);
        abrirModalDetalle();
      }
      setLoading(false);
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto:
          error.response?.data?.message ||
          "Error al cargar los datos de publicidad",
        icono: "error",
      });
      setLoading(false);
    }
  };

  // Licores
  const selectLicores = async (idcomercio) => {
    setLoading(true);
    try {
      const response = await licoresService.getLicores(
        idcomercio,
        token,
        op.conexion,
      );

      if (response.status === 200) {
        setComercioL(response.mappedData.comercio);
        setDeudaL(response.mappedData.deuda);
        setHistoricoL(response.mappedData.historico);
        setDeclaWeb(response.mappedData.declaWeb);
        setValorUTL(response.mappedData.valorPetro);
        abrirModalDetalle();
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: error.response?.data?.message || "Error al cargar los datos",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  //Solvencias
  const procesarSolvencias = async () => {
    try {
      if (body.nombre === "" || body.codigo === "") {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: "No se pudo Procesar la Solvencia",
          icono: "error",
        });
        return;
      }
      setLoading(true);
      const response = await solvenciasService.procesarSolvencias({
        operacion: 1,
        idSolve: 0,
        idContri: body.codigo,
        nombre: body.nombre,
        cedula: body.rif,
        dire: body.direccion,
        fecha: body.fecha,
        valido: "",
        dirigido: body.dirigido,
        solic: 0,
        fechaVenc: fechaUnMesMasFormat,
        token,
        conexion: op.conexion,
      });
      if (
        response.status === 200 &&
        response.data.length > 0 &&
        response.data[0].solvencia_act
      ) {
        const { solvencia_act } = response.data[0];
        setMensaje({
          mostrar: true,
          titulo: "",
          texto: `Solvencia N° ${solvencia_act} Registrado Correctamente`,
          icono: "exito",
        });
        imprimirSolvencia(solvencia_act);
        blanquear();
        blanquearSolvencias();
      } else {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: "No se pudo Procesar la Solvencia",
          icono: "error",
        });
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto:
          error.response?.data?.message || "Error al Procesar las Solvencias",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  //Marcar
  const marcarTodos = (datos) => {
    try {
      if (!datos) {
        datos = datosTabla;
      }
      if (datos && datos.length > 0) {
        setMarcados(datos.map((_, i) => i));
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: error || "Error al Marcar los Registros",
        icono: "error",
      });
    }
  };
  const desmarcarTodos = () => {
    try {
      setMarcados([]);
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: error || "Error al Desmarcar los Registros",
        icono: "error",
      });
    }
  };
  const marcarTabla = (index) => {
    try {
      setMarcados((prev) => {
        if (prev.includes(index)) {
          return prev.filter((i) => i !== index);
        }
        return [...prev, index];
      });
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: error || "Error al Marcar el Registro",
        icono: "error",
      });
    }
  };
  const calcularMontos = (item) => {
    try {
      if (item && item.length > 0) {
        let monto = 0;
        item.forEach((e, index) => {
          if (marcados.includes(index)) {
            monto += parseFloat(e.mto_periodo || 0);
          }
        });
        if (monto > 0) {
          setDisabledSolv(true);
        } else {
          setDisabledSolv(false);
        }
        setDeudaTotal(monto.toFixed(2));
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: error || "Error al Calcular los Montos",
        icono: "error",
      });
    }
  };
  useEffect(() => {
    if (datosTabla.length > 0) {
      calcularMontos(datosTabla);
    }
  }, [marcados, datosTabla, calcularMontos]);
  //reporte
  const imprimir = async () => {
    try {
      let rif = body.rif.trim();
      let cedula = body.cedula.trim();
      if (body.filtro.id === "cedula") {
        rif = cedula;
      } else if (body.filtro.id === "rif") {
        cedula = rif;
      }

      const formatPeriodo = (periodo) => {
        if (!periodo) return "N/A";
        const periodoStr = String(periodo);
        if (periodoStr.length !== 6) return "N/A";
        return `${periodoStr.slice(4, 6)}-${periodoStr.slice(0, 4)}`;
      };

      const formatFecha = (fecha) => {
        if (!fecha) return "N/A";
        try {
          return new Date(fecha).toLocaleDateString("es-ES", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          });
        } catch {
          return "N/A";
        }
      };

      // Agrupar datos por tipo de impuesto
      const grupos = datosTabla.reduce((acc, item) => {
        const tipo = item.tipoimpuesto || "Sin clasificar";
        if (!acc[tipo]) acc[tipo] = [];
        acc[tipo].push(item);
        return acc;
      }, {});

      const totalGeneral = datosTabla.reduce(
        (sum, item) => sum + parseFloat(item.mto_periodo || 0),
        0,
      );

      // Construcción de las filas de la tabla
      let filasTabla = "";
      Object.entries(grupos).forEach(([tipo, items]) => {
        filasTabla += `
          <tr style="background: #f0f4f8; font-weight: bold; text-transform: uppercase;">
            <td colspan="8" style="padding: 2px 3px;">Tipo de Impuesto: ${tipo}</td>
          </tr>
        `;
        items.forEach((item) => {
          filasTabla += `
            <tr>
              <td style="text-align: center; padding: 2px 3px;">${item.codigo || ""}</td>
              <td style="text-align: center; padding: 2px 3px;">${item.rif || ""}</td>
              <td style="text-align: left; padding: 2px 3px;">${item.nombre || ""}</td>
              <td style="text-align: left; padding: 2px 3px;">${item.direccion || ""}</td>
              <td style="text-align: center; padding: 2px 3px;">${item.reprelegal || ""}</td>
              <td style="text-align: center; padding: 2px 3px;">${formatPeriodo(item.periodopagado)}</td>
              <td style="text-align: center; padding: 2px 3px;">${formatFecha(item.paga)}</td>
              <td style="text-align: right; padding: 2px 3px;">${formatMoneda(item.mto_periodo.toString().replace(".", ","), ",", ".", 2)}</td>
            </tr>
          `;
        });
        const totalGrupo = items.reduce(
          (sum, i) => sum + parseFloat(i.mto_periodo || 0),
          0,
        );
        filasTabla += `
          <tr style="background: #e9ecef; font-weight: bold;">
            <td colspan="7" style="text-align: right; padding: 2px 3px;">Total ${tipo}:</td>
            <td style="text-align: right; padding: 2px 3px;">${formatMoneda(totalGrupo.toString().replace(".", ","), ",", ".", 2)}</td>
          </tr>
        `;
      });

      // ========== URL de las imágenes ==========
      const imagenLargaSrc = `${op.conexion}/imagen?img=logoLargo.jpg`;

      // ========== Construcción del HTML ==========
      const elemento = document.createElement("div");
      elemento.innerHTML = `
        <div style="font-family: Arial, sans-serif; font-size: 10px; padding: 12px 18px; max-width: 1100px; background: white;">
  
          <!-- ==================== ENCABEZADO CON IMAGEN LARGA ==================== -->
          <div style="display: flex; flex-direction: column; border-bottom: 3px solid #055182; padding-bottom: 8px; margin-bottom: 10px;">
            <!-- Imagen larga (banner) -->
            <div style="text-align: center;">
              <img 
                src="${imagenLargaSrc}" 
                alt="Banner institucional" 
                style="width: 100%; height: auto; max-height: 90px; object-fit: contain; border-radius: 4px;"
                onerror="this.style.display='none'"
              />
            </div>
          </div>
  
          <!-- ==================== TÍTULO ==================== -->
          <div style="text-align: center; font-size: 14px; font-weight: bold; color: #055182; margin: 4px 0 10px 0; text-transform: uppercase; letter-spacing: 1px;">
            DEUDA GENERAL DEL CONTRIBUYENTE
          </div>
  
          <!-- ==================== DATOS DEL CONTRIBUYENTE ==================== -->
          <div style="background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 4px; padding: 6px 10px; margin-bottom: 10px; font-size: 8.5px;">
            <div style="margin-bottom: 2px;"><b style="color: #055182; display: inline-block; width: 110px;">Contribuyente:</b> ${rif}</div>
            <div style="margin-bottom: 2px;"><b style="color: #055182; display: inline-block; width: 110px;">Cédula / RIF:</b> ${cedula}</div>
            <div style="margin-bottom: 2px;"><b style="color: #055182; display: inline-block; width: 110px;">Nombre:</b> ${body.nombre || ""}</div>
            <div style="margin-bottom: 0;"><b style="color: #055182; display: inline-block; width: 110px;">Dirección:</b> ${body.direccion || ""}</div>
          </div>
  
          <!-- ==================== TABLA DE DEUDAS ==================== -->
          <table style="width: 100%; border-collapse: collapse; font-size: 6.8px; table-layout: fixed;">
            <thead>
              <tr>
                <th style="background: #055182; color: white; padding: 3px 2px; border: 1px solid #04436d; text-align: center; vertical-align: middle; white-space: nowrap; width: 8%;">Código</th>
                <th style="background: #055182; color: white; padding: 3px 2px; border: 1px solid #04436d; text-align: center; vertical-align: middle; white-space: nowrap; width: 10%;">RIF</th>
                <th style="background: #055182; color: white; padding: 3px 2px; border: 1px solid #04436d; text-align: center; vertical-align: middle; white-space: nowrap; width: 20%;">Nombre</th>
                <th style="background: #055182; color: white; padding: 3px 2px; border: 1px solid #04436d; text-align: center; vertical-align: middle; white-space: nowrap; width: 20%;">Dirección</th>
                <th style="background: #055182; color: white; padding: 3px 2px; border: 1px solid #04436d; text-align: center; vertical-align: middle; white-space: nowrap; width: 12%;">Rep. Legal</th>
                <th style="background: #055182; color: white; padding: 3px 2px; border: 1px solid #04436d; text-align: center; vertical-align: middle; white-space: nowrap; width: 10%;">Período</th>
                <th style="background: #055182; color: white; padding: 3px 2px; border: 1px solid #04436d; text-align: center; vertical-align: middle; white-space: nowrap; width: 10%;">Fecha Pago</th>
                <th style="background: #055182; color: white; padding: 3px 2px; border: 1px solid #04436d; text-align: center; vertical-align: middle; white-space: nowrap; width: 10%;">Monto (Bs)</th>
              </tr>
            </thead>
            <tbody>
              ${filasTabla}
            </tbody>
          </table>
  
          <!-- ==================== TOTAL GENERAL ==================== -->
          <div style="margin-top: 6px; page-break-inside: avoid;">
            <div style="text-align: right; font-weight: bold; font-size: 10px; padding: 5px 8px; border: 2px solid #055182; background: #e0f2fe; border-radius: 4px;">
              TOTAL DEUDA GENERAL: ${formatMoneda(totalGeneral.toString().replace(".", ","), ",", ".", 2)} Bs
            </div>
          </div>
  
        </div>
      `;

      // ========== CONFIGURACIÓN DE html2pdf ==========
      const opciones = {
        margin: [8, 10, 12, 10], // arriba, derecha, abajo, izquierda (mm)
        filename: `Deuda_${cedula.replace(/[^a-zA-Z0-9]/g, "_")}_${new Date().toISOString().slice(0, 10)}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          letterRendering: true,
        },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "portrait",
        },
        pagebreak: {
          mode: ["avoid-all", "css", "legacy"],
        },
      };

      // Mostrar mensaje de carga
      setMensaje({
        mostrar: true,
        titulo: "GENERANDO PDF",
        texto: "Por favor espere...",
        icono: "success",
      });

      // Generar PDF como Blob
      const pdfBlob = await html2pdf()
        .set(opciones)
        .from(elemento)
        .output("blob");

      // Crear URL del objeto
      const url = URL.createObjectURL(pdfBlob);

      // Abrir en ventana emergente
      window.open(
        url,
        "ReporteDeuda",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );

      // Ocultar mensaje de carga
      setMensaje({
        mostrar: false,
        titulo: "",
        texto: "",
        icono: "",
      });
    } catch (error) {
      console.error("Error al generar el reporte:", error);
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: "Error al Generar el Reporte",
        icono: "error",
      });
    }
  };
  const imprimirSolvencia = (idSolven) => {
    try {
      const condicion = `idsolvencia = ${idSolven}`;
      window.open(
        op.reportes +
          "/actividadeconomica?" +
          "reporte=solvenciapaez" +
          "&CONDICION=" +
          condicion +
          `&RIFORG=${afiliado}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: "Error al Generar el Reporte de Solvencias",
        icono: "error",
      });
    }
  };
  const blanquear = () => {
    setDeudaTotal("0,00");
    setDisabled(false);
    // Modales y Visibilidad
    setMostrarModal({
      comercio: false,
      inmueble: false,
      vehiculo: false,
    });
    setMostrarDetalles({
      actividad: false,
      publicidad: false,
      licores: false,
      vehiculos: false,
      inmobiliaria: false,
      aseo: false,
      local: false,
      terminal: false,
      comresis: false,
    });

    // Comercio
    setComercio(null);
    setPersona(null);
    setActividad([]);
    setActividadxCome([]);
    setInmuebleCome([]);
    setDeuda([]);
    setHistorico([]);
    setMultas([]);
    setFacturasPagadas([]);
    setRetencion([]);

    // Inmueble
    setInmuebleI(undefined);
    setDeudaI(undefined);
    setHistoricoI(undefined);
    setFacturaRI(undefined);
    setCreditoI(undefined);

    // Aseo
    setInmobiliaria(undefined);
    setEntidad(undefined);
    setCredito(undefined);
    setRentas(undefined);
    setDeudaA(undefined);
    setHistoricoA(undefined);
    setValorUT(undefined);

    // Vehiculo
    setVehiculo(undefined);
    setDeudaV(undefined);
    setMultasV(undefined);
    setHistoricoV(undefined);

    // Publicidad
    setComercioP(undefined);
    setPersonaP(undefined);
    setDeudaP(undefined);
    setHistory(undefined);
    setTotal(undefined);
    setRecargo(undefined);
    setValorut(undefined);

    // Licores
    setComercioL(undefined);
    setDeudaL(undefined);
    setHistoricoL(undefined);
    setDeclaWeb(undefined);
    setValorUTL(undefined);

    // Principal / UI
    setDatosTabla([]);
    setLoading(false);
    setLoadingDeuda(false);
    setItemSelect({
      index: -1,
      item: "",
    });

    // Formulario Body
    setBody({
      tipoImpuesto: tipoImpuesto[0],
      filtro: filtro[0],
      rif: "",
      codigo: "",
      cedula: "",
      nombre: "",
      direccion: "",
      fecha: fechaFormat,
      dirigido: "",
    });

    setMensajesino({
      mostrar: false,
      titulo: "",
      texto: "",
      icono: "",
    });
    setDisabledSolv(true);
  };
  const blanquearSolvencias = () => {
    setMarcados([]);
    // Solvencias

    if (props.modal) {
      cerrar();
    }
  };
  const cerrar = () => {
    props.show();
  };
  useEffect(() => {
    blanquear();
    seleccionarFactorCambio();
    if (props.modal && props.codigo) {
      buscarDatosGenerales(props.codigo);
    }
  }, [props]);
  useEffect(() => {
    if (itemSelect.index >= 0) {
      buscarDetalles();
    }
  }, [itemSelect]);
  return (
    <div
      className={
        props.modal
          ? "col-12 p-1 py-0 text-uppercase border-table"
          : "col-11 p-1 m-2 text-uppercase border-table"
      }
      style={{
        maxHeight: "99vh",
      }}
    >
      <header className="col-12 azulGradiant py-2 d-flex align-items-center justify-content-between text-light border-bottom">
        <h3 className="fw-bold text-light m-0">
          {props.solvencia
            ? "Consulta de Solvencias Municipales"
            : "Consulta General de Deudas"}
        </h3>
        <button onClick={() => cerrar()} className="btn btn-sm bg-light">
          <i className="fa fa-times"></i>
        </button>
      </header>
      <div className="d-flex justify-content-between">
        <div className={`col-md-${props.modal ? 5 : 4} mr-auto row my-1 py-1`}>
          <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
            <span
              className="input-group-text text-uppercase"
              id="inputGroup-sizing-sm"
            >
              Tipo de Impuesto:
            </span>
            <select
              className="form-select form-control text-uppercase"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              value={tipoImpuesto.findIndex(
                (imp) => imp.label === body.tipoImpuesto.label,
              )}
              disabled={disabled}
              onChange={(e) => {
                const selectedImpuesto = tipoImpuesto[parseInt(e.target.value)];
                setBody((prev) => ({
                  ...prev,
                  rif: "",
                  codigo: "",
                  cedula: "",
                  nombre: "",
                  direccion: "",
                  tipoImpuesto: selectedImpuesto,
                }));
                setDatosTabla("");
              }}
            >
              {tipoImpuesto.map((e, index) => (
                <option key={index} value={index}>
                  {e.label}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className={`col-md-${props.modal ? 3 : 2} mr-auto row my-1 py-1`}>
          <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
            <span
              className="input-group-text text-uppercase"
              id="inputGroup-sizing-sm"
            >
              Busca por:
            </span>
            <select
              className="form-select form-control text-uppercase"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              value={filtro.findIndex((imp) => imp.label === body.filtro.label)}
              disabled={disabled}
              onChange={(e) => {
                const selectedfiltro = filtro[parseInt(e.target.value)];
                setBody((prev) => ({
                  ...prev,
                  filtro: selectedfiltro,
                }));
              }}
            >
              {filtro.map((e, index) => (
                <option key={index} value={index}>
                  {e.label}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className={`col-md-${props.modal ? 3 : 2} ml-auto row my-1 py-1`}>
          <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
            <span
              className="input-group-text text-uppercase"
              id="inputGroup-sizing-sm"
            >
              Fecha:
            </span>
            <input
              type="date"
              className="form-control text-uppercase"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              defaultValue={fechaFormat}
              disabled
            />
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-between">
        <div className={`col-md-2 mx-0 mr-1 px-0 row my-1 py-1`}>
          <div className="input-group input-group-sm col-md-10 p-0 m-0 mb-0">
            <span
              className="input-group-text text-uppercase"
              id="inputGroup-sizing-sm"
            >
              Código:
            </span>
            <input
              type="text"
              className="form-control text-uppercase"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              name="codigo"
              onKeyUp={handleInputNumChange}
              onBlur={handleInputNumChange}
              onChange={handleChange}
              value={body.codigo}
              disabled={disabled}
            />
            <button
              onClick={() => abrirCatalogo()}
              style={{ textAlign: "center", color: "white" }}
              className="btn btn-sm btn-info"
              disabled={disabled}
            >
              <i className="fas fa-search"></i>{" "}
            </button>
          </div>
        </div>
        <div
          className={`col-md-${props.modal ? 4 : 3} mx-0 mr-1 px-0 row my-1 py-1`}
        >
          <div className="input-group input-group-sm col-md-6 p-0 m-0 mb-0">
            <span
              className="input-group-text text-uppercase"
              id="inputGroup-sizing-sm"
            >
              Cedula/Rif:
            </span>
            <input
              type="text"
              className="form-control text-uppercase"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              name="cedula"
              value={body.rif}
              disabled
            />
          </div>
        </div>
        <div
          className={`col-md-${props.modal ? 6 : 7} mx-0 pr-2 px-0 row my-1 py-1`}
        >
          <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
            <span
              className="input-group-text text-uppercase"
              id="inputGroup-sizing-sm"
            >
              Nombre:
            </span>
            <input
              type="text"
              className="form-control text-uppercase"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              name="nombre"
              value={body.nombre}
              disabled
            />
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-between">
        <div className="col-md-6 mx-0 mr-1 px-0 row my-1 py-1">
          <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
            <span
              className="input-group-text text-uppercase"
              id="inputGroup-sizing-sm"
            >
              Direccion:
            </span>
            <textarea
              type="textarea"
              style={{ minHeight: 27 }}
              className="form-control text-uppercase"
              name="direccion"
              value={body.direccion}
              disabled
            />
          </div>
        </div>
        {props.solvencia && (
          <div className="col-md-6 ml-auto row my-1 py-1">
            <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
              <span
                className="input-group-text text-uppercase"
                id="inputGroup-sizing-sm"
              >
                Para Tramites en:
              </span>
              <textarea
                type="textarea"
                style={{ minHeight: 27 }}
                className="form-control text-uppercase"
                name="dirigido"
                onChange={handleChange}
                value={body.dirigido}
              />
            </div>
          </div>
        )}
      </div>
      <div className="col-12 m-0 p-0">
        <header className="col-12 azulGradiant py-2 d-flex align-items-center justify-content-between rounded-top text-light border-bottom border-top">
          <h5 className="fw-bold text-light m-0">Deudas del Contribuyente</h5>
        </header>
        <div className="col-12 m-0 p-0">
          <div style={{ maxHeight: "350px", overflowY: "auto" }}>
            <TblContainer>
              <TblHead />
              <tbody>
                {datosTabla &&
                  recordsAfterPagingAndSorting().map((item, index) => (
                    <tr
                      key={index}
                      style={{
                        padding: "0",
                        cursor: "pointer",
                        background:
                          itemSelect.index === index ? "lightskyblue" : "white",
                      }}
                      onClick={(e) => {
                        marcarTabla(index);
                      }}
                    >
                      <td
                        className="align-baseline"
                        style={{
                          fontSize: "11px",
                          textAlign: "center",
                          width: "10px",
                        }}
                      >
                        {props.solvencia && (
                          <input
                            type="checkbox"
                            checked={marcados.includes(index)}
                          />
                        )}
                      </td>

                      <td
                        className="align-baseline"
                        style={{
                          fontSize: "11px",
                          textAlign: "center",
                          width: "50px",
                        }}
                      >
                        {item.codigo}
                      </td>
                      <td
                        className="align-baseline"
                        style={{
                          fontSize: "11px",
                          textAlign: "center",
                          width: "50px",
                        }}
                      >
                        {item.rif}
                      </td>
                      <td
                        className="align-baseline"
                        style={{
                          fontSize: "11px",
                          textAlign: "center",
                          width: "auto",
                        }}
                      >
                        {item.nombre}
                      </td>
                      <td
                        className="align-baseline"
                        style={{
                          fontSize: "11px",
                          textAlign: "center",
                          width: "auto",
                        }}
                      >
                        {item.direccion}
                      </td>
                      <td
                        className="align-baseline"
                        style={{
                          fontSize: "11px",
                          textAlign: "center",
                          width: "100px",
                        }}
                      >
                        {item.reprelegal}
                      </td>
                      <td
                        className="align-baseline"
                        style={{
                          fontSize: "11px",
                          textAlign: "center",
                          width: "auto",
                        }}
                      >
                        {item.tipoimpuesto ? item.tipoimpuesto.trim() : ""}
                      </td>
                      <td
                        className="align-baseline"
                        style={{
                          fontSize: "11px",
                          textAlign: "center",
                          width: "115px",
                        }}
                      >
                        {formatPeriodo(item.periodopagado)}
                      </td>
                      <td
                        className="align-baseline"
                        style={{
                          fontSize: "11px",
                          textAlign: "center",
                          width: "100px",
                        }}
                      >
                        {item.paga
                          ? moment.utc(item.paga).format("DD-MM-YYYY")
                          : "N/A"}
                      </td>
                      <td
                        className="align-baseline"
                        style={{
                          fontSize: "11px",
                          textAlign: "center",
                          width: "110px",
                        }}
                      >
                        {item.mto_periodo
                          ? formatMoneda(
                              item.mto_periodo.toString().replace(".", ","),
                              ",",
                              ".",
                              2,
                            )
                          : "0,00"}
                      </td>
                      <td
                        style={{
                          fontSize: "11px",
                          textAlign: "center",
                          width: "auto",
                        }}
                      >
                        <button
                          disabled={item.codigo === "S/N"}
                          onClick={() => seleccionarFila(item, index)}
                          className="btn btn-sm btn-info mx-1 rounded-pill"
                        >
                          <i className="fa fa-file text-white"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </TblContainer>
          </div>
          <div className="col-md-12 d-flex justify-content-between border-top mb-0 pb-0">
            <div className="col-md-6 text-start pt-1 d-flex flex-column">
              {props.solvencia && (
                <>
                  <div className="mb-0 pb-0">
                    <label
                      for="marcar"
                      className="fw-bold mr-2"
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      Marcar Todos
                    </label>
                    <input
                      type="radio"
                      id="marcar"
                      name="radio"
                      defaultChecked
                      onChange={(e) => {
                        marcarTodos("");
                      }}
                    />
                  </div>
                  <div className="mb-0 pb-0">
                    <label
                      for="desmarcar"
                      className="fw-bold mr-2"
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      Desmarcar Todos
                    </label>
                    <input
                      type="radio"
                      id="desmarcar"
                      name="radio"
                      onChange={(e) => {
                        desmarcarTodos();
                      }}
                    />
                  </div>
                </>
              )}
            </div>

            <div className="col-md-6  text-end pt-1">
              <span className="fw-bold mr-2">Monto Total Deuda: </span>
              {formatMoneda(
                deudaTotal.toString().replace(".", ","),
                ",",
                ".",
                2,
              )}
            </div>
          </div>

          <TblPagination />
        </div>

        <div className="d-flex justify-content-end border-top pt-1">
          {props.solvencia && (
            <>
              <button
                type="button"
                style={{ margin: "2px" }}
                className="fw-bold btn btn-success btn-sm rounded-pill"
                onClick={() => {
                  setMensajesino({
                    mostrar: true,
                    titulo: "Confirmación.",
                    texto:
                      "En este momento se procederá a formalizar la entrega de la solvencia municipal, \n está seguro formalizar dicha entrega?",
                    icono: "confirmacion",
                  });
                }}
                disabled={disabledSolv}
              >
                <i className="fas fa-file-pdf"> Procesar Solvencia</i>
              </button>
              <button
                type="button"
                style={{ margin: "2px" }}
                className="fw-bold btn btn-info btn-sm rounded-pill"
                onClick={() => {
                  setModalSolvencia(true);
                }}
              >
                <i className="fas fa-search"> Consultar Solvencia</i>
              </button>
            </>
          )}

          <button
            disabled={body.cedula === "" || body.rif === ""}
            onClick={() => imprimir()}
            type="button"
            style={{ margin: "2px" }}
            className="fw-bold btn btn-primary btn-sm rounded-pill"
          >
            <i className="fa fa-print"> Imprimir Deudas General</i>
          </button>
          {!props.estadoCuenta && (
            <button
              type="button"
              onClick={() => {
                blanquear();
              }}
              style={{ margin: "2px" }}
              className="fw-bold btn btn-danger btn-sm rounded-pill"
            >
              <i className="fa fa-window-close"> Cancelar</i>
            </button>
          )}
        </div>
      </div>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={() => procesarSolvencias()}
      />
      {/* Catalogos */}
      <CatalogoInmueble
        show={mostrarModal.inmueble}
        onHideCancelaCatInm={() =>
          setMostrarModal({
            inmueble: false,
          })
        }
        onHideAceptaCatInm={(
          idInmue,
          nomPropie,
          codCat,
          cedPropie,
          dirInmue,
        ) => {
          setBody((prev) => ({
            ...prev,
            codigo: idInmue,
            direccion: dirInmue,
          }));
          buscarDatosGenerales(idInmue);
        }}
      />
      <CatalagoVehiculo
        show={mostrarModal.vehiculo}
        onHideCancela={() => {
          setMostrarModal({
            vehiculo: false,
          });
        }}
        onHideAceptaCatCom={(idvehi, nombre, ritm, placa, direccion) => {
          setBody((prev) => ({
            ...prev,
            codigo: idvehi,
            direccion: direccion,
          }));
          buscarDatosGenerales(idvehi);
        }}
      />
      <CatalogoComercio
        show={mostrarModal.comercio}
        onHideCancelaCatCom={() => {
          setMostrarModal({
            comercio: false,
          });
        }}
        onHideAceptaCatCom={(idCome) => {
          setBody((prev) => ({
            ...prev,
            codigo: idCome,
          }));
          console.log(idCome);
          buscarDatosGenerales(idCome);
        }}
      />

      {/* Detalles Actividad Economica */}

      <ActualizarEstadoCuenta
        show={mostrarDetalles.actividad}
        onHideCancela={() =>
          setMostrarDetalles({
            actividad: false,
          })
        }
        actividad={actividad}
        comercio={comercio}
        actividadcome={actividad}
        representante={persona}
        tabdeuda={deuda}
        tabpago={historico}
        tabmulta={multas}
        tabreten={retencion}
        inmueble={inmuebleCome}
        factpago={facturasPagadas}
        factorCambio={factorCambio}
      />
      {/* Detalles Inmuebles */}
      <EstadoCuentaInmuebleModal
        show={mostrarDetalles.inmobiliaria}
        onHideCancela={() =>
          setMostrarDetalles({
            inmobiliaria: false,
          })
        }
        inmueble={inmuebleI}
        deuda={deudaI}
        historico={historicoI}
        facturaR={facturaRI}
        factorCambio={factorCambio}
        credito={creditoI}
        body={body}
      />

      {/* Renta / Aseo */}
      <EstadoCuentaRentas
        show={mostrarDetalles.aseo}
        onHideCancela={() => {
          setMostrarDetalles({
            aseo: false,
          });
        }}
        factorCambio={factorCambio}
        deuda={deudaA}
        historico={historicoA}
        inmobiliaria={inmobiliaria}
        rentas={renta}
        valorUT={valorUT}
        credito={credito}
      />

      {/* Vehiculo */}
      <ActualizarEstadoVehiculos
        factorCambio={factorCambio}
        vehiculo={vehiculo}
        operacion={2}
        deuda={deudaV}
        multa={multasV}
        historico={historicoV}
        show={mostrarDetalles.vehiculos}
        onHideRenderizar={() => {}}
        onHideCancela={() => {
          setMostrarDetalles({
            vehiculos: false,
          });
        }}
        body={body}
      />

      {/* Publicidad */}
      <ConsultarDeuda
        factorCambio={factorCambio}
        show={mostrarDetalles.publicidad}
        comercio={comercioP}
        persona={personaP}
        detalle={""}
        deuda={deudaP}
        valorut={valorut}
        history={history}
        total={total}
        recargo={recargo}
        onHideRenderizar={() => {}}
        onHideCancela={() => {
          setMostrarDetalles({
            publicidad: false,
          });
        }}
        operacion={2}
      />
      {/* Licores */}
      <ModalCuentaEstado
        show={mostrarDetalles.licores}
        comercio={comercioL}
        onHideCancela={() => {
          setMostrarDetalles({
            licores: false,
          });
        }}
        deuda={deudaL}
        historico={historicoL}
        declaWeb={declaWeb}
        petro={valorUTL}
      />
      <ModalComresis
        show={mostrarDetalles.comresis}
        onShow={() => {
          setMostrarDetalles({
            comresis: false,
          });
        }}
        rif={body.rif}
      />
      <Dimmer active={loading || loadingDeuda} inverted />

      <ModalSolvencia
        show={modalSolvencia}
        hidden={() => setModalSolvencia(false)}
      />
    </div>
  );
};

export default TablaConsultaGeneralDeudas;
